











import { Component, Vue, Prop } from 'vue-property-decorator';
import IconStarRounded from '@/components/IconStarRounded.vue';

@Component({
  components: {
    IconStarRounded,
  },
})
export default class RatingSelectAdvancedItem extends Vue {
  @Prop({ type: Boolean, default: false }) isActive!: boolean;
}
